interface ContactStepProps {
  customerName: string;
  phone: string;
  email: string;
  notes: string;
  onNameChange: (v: string) => void;
  onPhoneChange: (v: string) => void;
  onEmailChange: (v: string) => void;
  onNotesChange: (v: string) => void;
}

export default function ContactStep({
  customerName,
  phone,
  email,
  notes,
  onNameChange,
  onPhoneChange,
  onEmailChange,
  onNotesChange,
}: ContactStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <label
          htmlFor="customerName"
          className="block text-sm font-label font-medium text-foreground-800 mb-1.5"
        >
          Họ và tên <span className="text-accent-600">*</span>
        </label>
        <input
          id="customerName"
          type="text"
          name="customerName"
          value={customerName}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Nhập họ và tên của bạn"
          className="w-full px-4 py-3 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-900 font-body focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 placeholder:text-foreground-400"
        />
      </div>

      <div>
        <label
          htmlFor="phone"
          className="block text-sm font-label font-medium text-foreground-800 mb-1.5"
        >
          Số điện thoại <span className="text-accent-600">*</span>
        </label>
        <input
          id="phone"
          type="tel"
          name="phone"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder="VD: 0909 123 456"
          className="w-full px-4 py-3 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-900 font-body focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 placeholder:text-foreground-400"
        />
      </div>

      <div>
        <label
          htmlFor="email"
          className="block text-sm font-label font-medium text-foreground-800 mb-1.5"
        >
          Email <span className="text-foreground-400">(không bắt buộc)</span>
        </label>
        <input
          id="email"
          type="email"
          name="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          placeholder="Để nhận xác nhận lịch hẹn"
          className="w-full px-4 py-3 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-900 font-body focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 placeholder:text-foreground-400"
        />
      </div>

      <div>
        <label
          htmlFor="notes"
          className="block text-sm font-label font-medium text-foreground-800 mb-1.5"
        >
          Ghi chú <span className="text-foreground-400">(không bắt buộc)</span>
        </label>
        <textarea
          id="notes"
          name="notes"
          value={notes}
          maxLength={500}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="Ví dụ: tình trạng sức khỏe cần lưu ý, thời gian mong muốn..."
          rows={4}
          className="w-full px-4 py-3 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-900 font-body focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 placeholder:text-foreground-400 resize-none"
        />
        <p className="text-xs text-foreground-400 font-label mt-1 text-right">
          {notes.length}/500
        </p>
      </div>
    </div>
  );
}